module.exports = __webpack_public_path__ + "img/55.cec936d8.png";